<template>
    <div class="module-bomb">
        <v-layout align-center justify-left class="penalty">
            <img
                v-for="count in $userData.penalty"
                :key="count"
                :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/indicator_bomb${count === 3 ? '_last' : ''}.png`"
                :class="count === 3 ? 'last' : ''"
            />
        </v-layout>
    </div>
</template>

<script>
    export default {
    }
</script>

<style lang="scss" scoped>
    .module-bomb{
        width: 112.5px;
        height: 31.8px;
        margin-top: 13px;
        margin-left: 24.4px;
        display: inline-block;
        background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_bomb.png');
    }

    .penalty {
        margin-top: 12px;
        margin-left: 3px;

        img {
            width: 22px;
            height: 14px;

            &+img {
                margin-left: 2px;
            }


            &.last {
                width: 18px;
            }
        }
    }
</style>
